
export default function requireProps(props, requiredProps) {
  requiredProps.forEach(requiredProp => {
    if (!props[requiredProp]) {
      throw new Error(`${requiredProp} is a required prop`)
    }
  })
}
